import { jwtDecode } from "jwt-decode";

// --- Interfaces for Admin Token ---
interface DecodedAdminToken {
  adminData: AdminData;
  exp: number;
}

export interface AdminData {
  Id: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Roles: RoleData[];
}

interface RoleData {
  Id: number;
  RoleName: string;
  IsSuperAdmin?: boolean;
  Permissions: PermissionsData[];
}

interface PermissionsData {
  Id: number;
  IdAction: number;
  Action: string;
  IdModule: number;
  ModuleName: string;
}

class AdminTokenService {
  // --- Admin Token Methods ---

  setAdminToken(token: string): void {
    localStorage.setItem("adminAuthToken", token);
  }

  getAdminToken(): string | null {
    return localStorage.getItem("adminAuthToken");
  }

  removeAdminToken(): void {
    localStorage.removeItem("adminAuthToken");
  }

  getAdminDataToken(): DecodedAdminToken | null {
    const token = this.getAdminToken();
    if (token) {
      try {
        const decoded: DecodedAdminToken = jwtDecode(token);

        if (decoded.exp * 1000 < Date.now()) {
          console.error("Admin token has expired.");
          this.removeAdminToken();
          return null;
        }

        if (decoded && typeof decoded.adminData === "string") {
          decoded.adminData = JSON.parse(decoded.adminData as any);
        }

        return decoded;
      } catch (error) {
        console.error("Failed to decode admin token:", error);
        this.removeAdminToken();
        return null;
      }
    }
    return null;
  }
}

export const adminTokenService = new AdminTokenService();
